import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
// reducer
const Properties = ({
  handleEditProperty,
  handleDeleteProperty,
  properties,
  handleChangeFile
}) => {
  const handleEdit = property => {
    if (handleEditProperty && typeof handleEditProperty === "function") {
      handleEditProperty(property);
    }
  };
  const handleDelete = property => {
    if (handleDeleteProperty && typeof handleDeleteProperty === "function") {
      handleDeleteProperty(property);
    }
  };
  const _handleChangeFile = (e, property) => {
    if (handleChangeFile && typeof handleChangeFile === "function") {
      handleChangeFile(e, property, "property");
    }
  };
  const renderList = () => {
    if (!properties || properties.length <= 0) {
      return null;
    }
    return properties.map((property, key) => {
      if(!property.announcement) {return}
      const { files } = property.announcement.residence;
      let imgUrl = null;
      if (files && files.length !== 0) {
        imgUrl = `https://sopia.ams3.digitaloceanspaces.com/production/${files[0].key}`;
      }
      return (
        <div className="property-item" key={key}>
          {imgUrl ? (
            <img src={imgUrl} alt="avatar" className="avatar" />
          ) : (
            <i className="material-icons default-avatar">account_circle</i>
          )}
          <div className="text">{property.address || property.id}</div>
          <div className="text">
            Public: {property.publicDisplay ? "public" : "private"}
          </div>
          <div className="tool blue-tool" onClick={() => handleEdit(property)}>
            Edit {property.publicDisplay}
          </div>
          <div className="tool red-tool" onClick={() => handleDelete(property)}>
            Delete
          </div>
          <input type="file" onChange={e => _handleChangeFile(e, property)} />
        </div>
      );
    });
  };

  return <div className="admin-properties">{renderList()}</div>;
};

export default withRouter(connect()(Properties));
